import * as React from 'react'
import styled, { css } from 'styled-components'
import { Fonts } from '../../../../common/src/constants'
import { FetchThreadQuery } from '../../../../common/src/types.gen'
import { LazyLinkifiedText } from './LinkifiedText'

/**
 * Displays plain text with a few enhancements.
 *
 * Detects URLs and turns them into clickable links.
 */
export default class RichText extends React.PureComponent<{
  monospace?: boolean
  innerRef?: React.RefObject<HTMLDivElement>
  messageLinks?: FetchThreadQuery['thread']['messagesWithLinks']['messageLinks']
}> {
  render() {
    const { children, monospace, innerRef, messageLinks } = this.props

    if (typeof children !== 'string') {
      return children
    }

    const str = children as string
    return (
      <RichTextWrap monospace={monospace} ref={innerRef}>
        <LazyLinkifiedText messageLinks={messageLinks} text={str} />
      </RichTextWrap>
    )
  }
}

const RichTextWrap = styled.div`
  ${(props: { monospace?: boolean }) => css`
    white-space: pre-wrap;
    word-wrap: break-word;
    ${props.monospace && `font-family: ${Fonts.mono};`};
  `};
`
